import React, { useEffect, useRef, useState } from "react";
import {
    Box,
    Divider,
    FormControl,
    FormControlLabel,
    Grid,
    CircularProgress,
    InputLabel,
    Radio,
    RadioGroup,
    Typography,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    IconButton,
    Button,
    Tooltip,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    tableCellClasses,
} from "@mui/material";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
// import Papa from "papaparse";
import SelectField from "components/Select";
import { PrimaryButton } from "components/Buttons";
import { ErrorToaster, SuccessToaster } from "components/Toaster";
import Colors from "assets/Style/Colors";
import { v4 as uuidv4 } from "uuid";
import { FontFamily } from "assets";
import InputField from "components/Input";
import UploadFile from "components/UploadFile";
import DatePicker from "components/DatePicker";
import CustomerServices from "services/Customer";
import VehicleBookingServices from "services/VehicleBooking";
import instance from "config/axios";
import routes from "services/System/routes";
import SystemServices from "services/System";
import {
    CleanTypes,
    Debounce,
    getFileSize,
    getYearMonthDateFormate,
    numberRegex,
} from "utils";
import TitleStatus from "data/Title_Status";
import styled from "@emotion/styled";
import Compressor from "compressorjs";
import ClientServices from "services/Client";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Add } from "@mui/icons-material";

import { FiDownload } from "react-icons/fi";

import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DeleteIcon from '@mui/icons-material/Delete';

// import { styled } from "@mui/system";


const Row = styled(TableRow)(({ theme }) => ({
    border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        fontSize: 14,
        fontFamily: FontFamily.NunitoRegular,
        border: 0,
        textAlign: "left",
        whiteSpace: "nowrap",
        backgroundColor: Colors.primary,
        color: Colors.white,
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontFamily: FontFamily.NunitoRegular,
        textAlign: "left",
        textWrap: "nowrap",

        ".MuiBox-root": {
            display: "flex",
            gap: "6px",
            alignItems: "center",
            justifyContent: "center",
            ".MuiBox-root": {
                cursor: "pointer",
            },
        },
        svg: {
            width: "auto",
            height: "24px",
        },
        ".MuiTypography-root": {
            textTransform: "capitalize",
            fontFamily: FontFamily.NunitoRegular,
            textWrap: "nowrap",
        },
        ".css-1ru1j9e-MuiTableCell-root ": {
            color: "#ffffff",
            textAlign: "left",

        },
        ".MuiButtonBase-root": {
            padding: "8px",
            width: "28px",
            height: "28px",
        },
    },
}));


const Input = styled("input")({
    position: "absolute",
    left: 0,
    top: 0,
    width: "100%",
    height: "100%",
    display: "block",
    opacity: 0,
    fontSize: 0,
    cursor: "pointer",
    zIndex: 1,
});


const HiddenInput = styled("input")({ display: "none" });

function ImageThumbSlider({ images = [], visibleCount = 8, onRemove }) {
    const [index, setIndex] = useState(0);
    const canSlide = images.length > visibleCount;
    const safeIndex = Math.min(index, Math.max(0, images.length - visibleCount));

    useEffect(() => {
        if (index !== safeIndex) setIndex(safeIndex);
    }, [images.length, visibleCount]);

    const maxIndex = Math.max(0, images.length - visibleCount);
    const next = () => setIndex((i) => Math.min(i + 1, maxIndex));
    const prev = () => setIndex((i) => Math.max(i - 1, 0));

    const THUMB = 140;
    const GAP = 12;
    const translateX = -(THUMB + GAP) * index;

    if (!images.length) return null;

    return (
        <Box sx={{ mt: 2 }}>
            <Typography sx={{ fontWeight: 600, mb: 1 }}>Preview</Typography>

            <Box sx={{ position: "relative", display: "flex", alignItems: "center" }}>
                {canSlide && (
                    <IconButton
                        size="small"
                        onClick={prev}
                        disabled={index === 0}
                        sx={{ mr: 1 }}
                    >
                        <ChevronLeftIcon />
                    </IconButton>
                )}

                <Box
                    sx={{
                        overflow: "hidden",
                        width: canSlide ? (THUMB + GAP) * visibleCount - GAP : "auto",
                    }}
                >
                    <Box
                        sx={{
                            display: "flex",
                            gap: `${GAP}px`,
                            transform: `translateX(${translateX}px)`,
                            transition: "transform 240ms ease",
                        }}
                    >
                        {images.map((src, i) => (
                            <Box
                                key={src + i}
                                sx={{
                                    width: THUMB,
                                    height: THUMB,
                                    borderRadius: 1.5,
                                    overflow: "hidden",
                                    border: "1px solid #E0E0E0",
                                    position: "relative",
                                    flex: "0 0 auto",
                                }}
                            >
                                <img
                                    src={src}
                                    // alt={`upload-${i}`}
                                    style={{ width: "100%", height: "100%", objectFit: "cover" }}
                                />
                                {!!onRemove && (

                                    <IconButton

                                        onClick={() => onRemove(i)}
                                        sx={{
                                            minWidth: 0,
                                            position: "absolute",
                                            right: 4,
                                            top: 4,
                                            // px: 1,
                                            // py: 0,
                                            width: 24,
                                            height: 24,
                                            border: "1px solid #ddd",
                                            borderRadius: "50%",
                                            "&:hover": { bgcolor: "rgba(255,255,255,1)" },
                                            fontSize: 10,
                                            bgcolor: "#ffffffCC",
                                            textTransform: "none",
                                        }}


                                    >
                                        <DeleteIcon
                                            sx={{
                                                fontSize: '14px',
                                                color: Colors.danger,
                                            }}
                                        />
                                    </IconButton>
                                )}
                            </Box>
                        ))}
                    </Box>
                </Box>

                {/* Right arrow */}
                {canSlide && (
                    <IconButton
                        size="small"
                        onClick={next}
                        disabled={index === maxIndex}
                        sx={{ ml: 1 }}
                    >
                        <ChevronRightIcon />
                    </IconButton>
                )}
            </Box>
        </Box>
    );
}

export function AttachmentsCard({ onPickFiles, onGetImages, images = [], onRemove }) {
    return (
        <Grid container spacing={2}>
            <Grid item>
                <Box
                    sx={{
                        width: 350,
                        minHeight: 150,
                        p: 2.2,
                        border: "1.5px dashed #C8D3C8",
                        borderRadius: 2,
                        bgcolor: "#F6FBF7",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "center",
                        justifyContent: "center",
                    }}
                >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.75 }}>
                        <CloudUploadOutlinedIcon sx={{ fontSize: 18 }} />
                        <label htmlFor="vehicle-images-input" style={{ cursor: "pointer" }}>
                            <Typography component="span" sx={{ fontWeight: 600, fontSize: 14 }}>
                                Upload Vehicle Images
                            </Typography>
                        </label>

                        <Tooltip title="PNG/JPG • multiple files">
                            <IconButton size="small" sx={{ p: 0, ml: 0.25 }}>
                                <InfoOutlinedIcon sx={{ fontSize: 16 }} />
                            </IconButton>
                        </Tooltip>

                        <HiddenInput
                            id="vehicle-images-input"
                            type="file"
                            accept="image/png,image/jpg,image/jpeg"
                            multiple
                            onChange={onPickFiles}
                        />
                    </Box>

                    <Typography sx={{ my: 1.2, color: "#7A7A7A", fontSize: 13 }}>
                        or
                    </Typography>

                    <Button
                        variant="outlined"
                        size="small"
                        onClick={onGetImages}
                        sx={{
                            textTransform: "none",
                            borderColor: "#1B5E20",
                            color: "#1B5E20",
                            fontWeight: 600,
                            px: 2.5,
                            borderRadius: 1.2,
                        }}
                    >
                        Get Images
                    </Button>
                </Box>
            </Grid>

            <Grid item xs={12} sm={12}>
                <ImageThumbSlider images={images} visibleCount={8} onRemove={onRemove} />
            </Grid>
        </Grid>
    );
}


function CreateVehicleBookingV2() {
    const navigate = useNavigate();
    const viewerRef = useRef();

    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        control,
        getValues,
    } = useForm();

    const [loading, setLoading] = useState(false);
    const [pictureLoading, setPictureLoading] = useState(false);


    // const [expanded, setExpanded] = useState("customer");

    const [expanded, setExpanded] = useState({
        customer: true,
        vehicle: false,
        Spec: false,
        title: false,
        Attachment: false,
    });

    // const handleChange = (panel) => (event, isExpanded) => {
    //     setExpanded(isExpanded ? panel : false);
    // };

    const handleChange = (panel) => (_event, isExpanded) => {
        setExpanded(prev => ({ ...prev, [panel]: isExpanded }));
    };




    // *For Upload File types
    const allowFilesType = ["image/png", "image/jpg", "image/jpeg"];

    const allowFilesTypeInvoice = [
        "image/png",
        "image/jpg",
        "image/jpeg",
        "application/pdf",
    ];

    // *For Customer Booking
    const [customers, setCustomers] = useState([]);
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    // *For Buyer Id
    const [buyerId, setBuyerId] = useState([]);
    const [selectedBuyerId, setSelectedBuyerId] = useState(null);

    const [invoiceType, setInvoiceType] = useState([]);
    console.log(invoiceType, 'invoiceType');
    const [invoiceNumber, setInvoiceNumber] = useState("");

    const [invoiceList, setInvoiceList] = useState([]);
    console.log(invoiceList, 'invoiceList')

    // *For Currency
    const [currencies, setCurrencies] = useState([]);
    const [selectedCurrency, setSelectedCurrency] = useState(null);

    const [vinLength, setVinLength] = useState(false);

    // *For Make
    const [makes, setMakes] = useState([]);
    const [selectedMake, setSelectedMake] = useState(null);

    // *For Models
    const [models, setModels] = useState([]);
    const [selectedModel, setSelectedModel] = useState(null);

    // *For Color
    const [colors, setColors] = useState([]);
    const [selectedColor, setSelectedColor] = useState(null);

    // *For Title Name
    const [selectedTitleStatus, setSelectedTitleStatus] = useState(null);

    // *For Key
    const [key, setKey] = useState(false);

    // *For Title Status
    const [titleStatus, setTitleSatus] = useState("N/A");
    const [vehicleKey, setVehicleKey] = useState(false);
    const [titleIssue, setTitleIssue] = useState("no");

    const [keyLost, setKeyLost] = useState("no");
    const [vehicleCancell, setVehicleCancell] = useState("no");
    const [vehicleRelist, setVehicleRelist] = useState("no");



    console.log(titleIssue, 'titleIssue')

    const [extractVinLength, setExtractVinLength] = useState();
    // *For Vehicle Towers
    const [vehicleTowers, setVehicleTowers] = useState([]);
    const [selectedVehicleTower, setSelectedVehicleTower] = useState(null);

    // *For Countries
    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState(null);

    const [fileInputKey, setFileInputKey] = useState(Date.now());

    const [loader, setLoader] = useState(false);

    // *For States
    const [states, setStates] = useState([]);
    const [selectedState, setSelectedState] = useState(null);

    // *For Cities
    const [cities, setCities] = useState([]);
    const [selectedCity, setSelectedCity] = useState(null);

    // *For Pictures
    const [pictures, setPictures] = useState([]);
    console.log(pictures, 'pictre')
    const [invoicePictures, setInvoicePictures] = useState([]);

    // *For Handle Date
    const [titleReceiveDate, setTitleReceiveDate] = useState();
    const [purchaseDate, setPurchaseDate] = useState();
    const [pickupDate, setPickupDate] = useState();
    const [deliveryDate, setDeliveryDate] = useState();
    const [allLocations, setAllLocations] = useState([]);

    const [phoneNumber, setPhoneNumber] = useState();
    const [selectedPictureIndex, setSelectedPictureIndex] = useState(0);
    const [selectedWarehouse, setSelectedWarehouse] = useState(null);

    const [warehouses, setWarehouses] = useState([]);
    const [filteredTitleStatus, setFilteredTitleStatus] = useState(TitleStatus);

    const [selectedRate, setSelectedRate] = useState({ id: 3, name: "Auto" });
    const [modalOpen, setModalOpen] = useState(false);
    const [externalData, setExternalData] = useState();
    const [cadExRate, setCadExRate] = useState(0);
    const [progress, setProgress] = useState(0);
    const [uploadedSize, setUploadedSize] = useState(0);
    const [documentDetail, setDocumentDetail] = useState([]);
    const [documentLink, setDocumentLink] = useState("");
    const [documentDetail2, setDocumentDetail2] = useState([]);
    const [documentLink2, setDocumentLink2] = useState("");
    const [progress2, setProgress2] = useState(0);
    const [uploadedSize2, setUploadedSize2] = useState(0);


    // *For Destination
    const [destinations, setDestinations] = useState([]);
    const [selectedDestination, setSelectedDestination] = useState({
        id: 1,
        name: "Jebel Ali, Dubai, UAE",
    });
    useEffect(() => {
        setValue("destination", selectedDestination); // set default for form
    }, []);
    const handlePictureClick = (index) => {
        viewerRef.current && viewerRef.current.click();

        // Move the clicked picture to index 0
        const updatedPictures = [...pictures];
        const clickedPicture = updatedPictures.splice(index, 1)[0];
        updatedPictures.unshift(clickedPicture);

        setPictures(updatedPictures);
        setSelectedPictureIndex(0);
    };

    const rateTypeOptions = [
        { id: 1, name: "Normal Bike" },
        { id: 2, name: "Oversize Bike" },
        { id: 3, name: "Auto" },
        { id: 4, name: "Container Price" },
        { id: 5, name: "Scrap Price" },
        { id: 6, name: "Cutting" },
    ];

    // *For Remove Picture
    const removePicture = (index) => {
        try {
            let shallowPicture = [...pictures];
            shallowPicture.splice(index, 1);
            setPictures(shallowPicture);
        } catch (error) {
            ErrorToaster(error);
        }
    };
    const getDestinations = async (search, defaultId) => {
        try {
            let params = {
                page: 1,
                limit: 50,
                search: search,
            };
            const { data } = await SystemServices.getDestinations(params);

            setDestinations(data?.destinations?.rows);
        } catch (error) {
            ErrorToaster(error);
        }
    };
    // *For Handle Date
    const handleTitleReceiveDate = (newDate) => {
        try {
            // eslint-disable-next-line eqeqeq
            if (newDate == "Invalid Date") {
                setTitleReceiveDate("invalid");
                return;
            }
            setTitleReceiveDate(new Date(newDate));
        } catch (error) {
            ErrorToaster(error);
        }
    };

    const handlePurchaseDate = (newDate) => {
        try {
            // eslint-disable-next-line eqeqeq
            if (newDate == "Invalid Date") {
                setPurchaseDate("invalid");
                return;
            }
            setPurchaseDate(new Date(newDate));
            setValue("purchaseDate", newDate);
        } catch (error) {
            ErrorToaster(error);
        }
    };

    const removeDoc = () => {
        try {
            setDocumentDetail([]);
            setDocumentLink("");
            // setValue2('scanned', '')
        } catch (error) {
            ErrorToaster(error);
        }
    };

    const removeDoc2 = () => {
        try {
            setDocumentDetail2([]);
            setDocumentLink2("");
            // setValue2('scanned', '')
        } catch (error) {
            ErrorToaster(error);
        }
    };


    const handlePickupDate = (newDate) => {
        try {
            // eslint-disable-next-line eqeqeq
            if (newDate == "Invalid Date") {
                setPickupDate("invalid");
                return;
            }
            setPickupDate(new Date(newDate));
        } catch (error) {
            ErrorToaster(error);
        }
    };

    const handleDeliveryDate = (newDate) => {
        try {
            // eslint-disable-next-line eqeqeq
            if (newDate == "Invalid Date") {
                setDeliveryDate("invalid");
                return;
            }
            setDeliveryDate(new Date(newDate));
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // *For Get Currencies
    const getCurrencies = async () => {
        try {
            let params = {
                detailed: true,
            };
            const { data } = await SystemServices.getCurrencies(params);
            const currenciesArray = [];
            data?.currencies?.forEach((element) => {
                let obj = {
                    id: element?.currency,
                    name: element?.currency.toUpperCase(),
                    rate: element?.conversion_rate,
                };
                currenciesArray.push(obj);
            });
            const filteredArray = currenciesArray.filter(
                (item) => item.id !== "aed" && item.id !== "cad"
            );
            // setValue('bookingRate', filteredArray[0]?.rate)
            setCadExRate(filteredArray[0]?.rate);
            setCurrencies(filteredArray);
            setValue("currency", filteredArray);
            setSelectedCurrency({id: filteredArray[0]?.id, name: filteredArray[0]?.name})
            setValue("bookingRate", filteredArray[0]?.rate);
        } catch (error) {
            ErrorToaster(error);
        }
    };
console.log(currencies, '..currencies')
    // *For Get Makes
    const getMakes = async (search) => {
        try {
            let params = {
                page: 1,
                limit: 50,
                search: search,
            };
            const { data } = await SystemServices.getMakes(params);

            // Remove duplicates based on the make name (case insensitive)
            const uniqueMakes = data?.makes?.rows.filter(
                (make, index, self) =>
                    index ===
                    self.findIndex(
                        (m) =>
                            m.name.trim().toLowerCase() === make.name.trim().toLowerCase()
                    )
            );

            setMakes(uniqueMakes);
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // *For Get Colors
    const getModels = async (id, search, excelValue) => {
        try {
            let params = {
                page: 1,
                limit: 50,
                make_id: selectedMake?.id ? selectedMake?.id : id,
                search: search,
            };
            const { data } = await SystemServices.getModels(params);
            setModels(data?.models?.rows);

            if (excelValue) {
                const findModel = data?.models?.rows.find(
                    (e) => e?.name.toLowerCase() === excelValue.toLowerCase()
                );
                if (findModel) {
                    setSelectedModel(findModel);
                    setValue("model", findModel?.name);
                } else {
                    createModel({ name: excelValue });
                }
            }
            return data?.models?.rows;
        } catch (error) {
            ErrorToaster(error);
        }
    };




    const handleUploadDocumentInvoices = async (e) => {
        try {
            e.preventDefault();
            const file = e.target.files[0];
            let arr = [
                {
                    id: uuidv4(),
                    name: file?.name,
                    file: "",
                    type: file?.type.split("/")[1],
                    size: getFileSize(file.size),
                    isUpload: false,
                },
            ];
            if (allowFilesTypeInvoice.includes(file.type)) {
                setDocumentDetail2(arr);
                handleUploadInvoices(file, arr);
            } else {
                ErrorToaster(`Only ${CleanTypes(allowFilesTypeInvoice)} formats is supported`);
            }
        } catch (error) {
            ErrorToaster(error);
        }
    };

    const handleUploadInvoices = async (file, docs) => {
        setProgress(0);
        try {
            const formData = new FormData();
            formData.append("document", file);
            const { data } = await instance.post(routes.uploadDocuments, formData, {
                onUploadProgress: (progressEvent) => {
                    const uploadedBytes = progressEvent.loaded;
                    const percentCompleted = Math.round(
                        (uploadedBytes * 100) / progressEvent.total
                    );

                    setProgress2(percentCompleted);
                    setUploadedSize2(getFileSize(uploadedBytes));
                },
            });
            if (data) {
                docs[0].isUpload = true;
                docs[0].file = data?.data?.nations;
                setDocumentDetail2(docs);
                setDocumentLink2(data?.data?.nations);
                SuccessToaster("Document Uploaded")
            }
        } catch (error) {
            ErrorToaster(error);
        }
    };


    const handleAddDocument = () => {

        if (!documentLink2) {
            ErrorToaster("Please upload a document before adding.");
            return;
        }

        if (!invoiceType?.id) return ErrorToaster("Please enter Invoice Type");
        // if (!invoiceNumber?.trim()) return ErrorToaster("Please enter Invoice Number");

        setInvoiceList([
            ...invoiceList,
            {
                id: uuidv4(),
                invoiceType: invoiceType?.id,
                invoiceTypeName: invoiceType?.name,
                // invoiceNumber: invoiceNumber,
                documentLink2,
            },
        ]);
        SuccessToaster("Document Added")
        setInvoiceType([]);
        setInvoiceNumber("");
        setDocumentLink2("");
    };





    // *For Get Colors
    const getColors = async (search) => {
        try {
            let params = {
                page: 1,
                limit: 50,
                search: search,
            };
            const { data } = await SystemServices.getColors(params);
            setColors(
                data?.colors.map((item) => {
                    return { id: item, name: item };
                })
            );
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // *For Get Countries
    const getCountries = async () => {
        try {
            const { data } = await SystemServices.getBusinessCountries();
            setCountries(data?.countries);
        } catch (error) {
            ErrorToaster(error);
        }
    };
    // *For Get Countries
    const getAllLocations = async () => {
        try {
            const { data } = await SystemServices.getBusinessLocation();
            setAllLocations(data?.locations);
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // *For Get States

    const getStates = async (countryId, search = "") => {
        try {
            const { data } = await SystemServices.getBusinessLocation(
                countryId,
                search
            );
            // Map locations to desired format
            let mappedLocations =
                data?.locations?.map((item) => ({
                    id: item.id,
                    name: `${item?.state_code} - ${item?.city_name}`,
                })) || [];

            // Remove duplicates by id or name (depending on which you want to use as unique key)
            const uniqueLocations = mappedLocations.filter(
                (loc, index, self) => index === self.findIndex((t) => t.id === loc.id)
            );

            setStates(uniqueLocations);
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // const getStates = async (countryId, search = "") => {
    //   try {
    //     const { data } = await SystemServices.getBusinessLocation(
    //       countryId,
    //       search
    //     );
    //     setStates(
    //       data?.locations?.map((item) => ({
    //         id: item.id,
    //         name: `${item?.state_code} - ${item?.city_name}`,
    //       }))
    //     );
    //   } catch (error) {
    //     ErrorToaster(error);
    //   }
    // };

    // *For Get Cities
    const getCities = async (stateId) => {
        try {
            const { data } = await SystemServices.getCities(stateId);
            setCities(data?.cities.rows);
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // *For Get Customer Booking
    const getCustomerBooking = async (search) => {
        try {
            let params = {
                name: search ?? "",
            };
            const { data } = await CustomerServices.getCustomerBooking(params);
            setCustomers(data?.customers);
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // *For Get Customer Buyer ID
    const getCustomerBuyerId = async (id) => {
        try {
            let params = { customerID: id };
            const { data } = await CustomerServices.getCustomerBuyerId(params);
            setBuyerId(data?.details);
            setValue("buyerId", data?.details[0]?.id);
            setValue("masterID", data?.details[0]?.master_id)
            setSelectedBuyerId(data?.details[0]);
            setValue("auctioneer", data?.details[0]?.auction?.name);
        } catch (error) {
            ErrorToaster(error);
        }
    };

    // *For Set Customer Detail
    const setCustomerDetail = (data) => {
        if (data) {
            getCustomerBuyerId(data?.id);
            setValue("customerId", data?.ref_id);
            setPhoneNumber(data?.uae_phone);

            setValue("contactNumber", data?.uae_phone);
            setValue("email", data?.email);
        }
    };



    const removeExtension = (fileName) =>
        fileName.substring(0, fileName.lastIndexOf(".")) || fileName;
    // *For Upload Document
    const allPictures = [...pictures];

    const handleUploadDocument = async (e) => {
        setPictureLoading(true);

        try {
            e.preventDefault();
            const files = Array.from(e.target.files);

            const uploadPromises = [];

            for (let i = 0; i < files.length; i++) {
                const element = files[i];

                if (allowFilesType.includes(element.type)) {
                    const promise = new Promise((resolve, reject) => {
                        new Compressor(element, {
                            quality: 0.8,
                            success: (compressedFile) => {
                                if (compressedFile instanceof File) {
                                    handleUpload(compressedFile);
                                    resolve(compressedFile);
                                } else {
                                    const compressedFileFromBlob = new File(
                                        [compressedFile],
                                        removeExtension(element.name),
                                        {
                                            type: compressedFile.type,
                                        }
                                    );
                                    handleUpload(compressedFileFromBlob);
                                    resolve(compressedFileFromBlob);
                                }
                            },
                            error: reject,
                        });
                    });

                    uploadPromises.push(promise);
                } else {
                    ErrorToaster(
                        `Only ${CleanTypes(allowFilesType)} formats are supported`
                    );
                }
            }

            // Wait for all promises to resolve
            const result = await Promise.all(uploadPromises);

            // Set the file input key outside the loop
            setFileInputKey(Date.now());
        } catch (error) {
            ErrorToaster(error);
        }
    };
    const handleUpload = async (file) => {
        try {
            const formData = new FormData();
            formData.append("document", file);
            const { data } = await instance.post(routes.uploadDocuments, formData);
            if (data) {
                allPictures.push(data?.data?.nations);
                Debounce(() => setPictures(allPictures));
            }
        } catch (error) {
            ErrorToaster(error);
        } finally {
            setPictureLoading(false);
        }
    };
    const handleUploadInvoice = async (file, docs) => {
        setProgress(0);
        try {
            const formData = new FormData();
            formData.append("document", file);
            const { data } = await instance.post(routes.uploadDocuments, formData, {
                onUploadProgress: (progressEvent) => {
                    const uploadedBytes = progressEvent.loaded;
                    const percentCompleted = Math.round(
                        (uploadedBytes * 100) / progressEvent.total
                    );

                    setProgress(percentCompleted);
                    setUploadedSize(getFileSize(uploadedBytes));
                },
            });
            if (data) {
                docs[0].isUpload = true;
                docs[0].file = data?.data?.nations;
                setDocumentDetail(docs);
                setDocumentLink(data?.data?.nations);
                SuccessToaster("Document Added")
            }
        } catch (error) {
            ErrorToaster(error);
        }
    };
    const handleUploadDocumentInvoice = async (e) => {
        try {
            e.preventDefault();
            const file = e.target.files[0];
            let arr = [
                {
                    id: uuidv4(),
                    name: file?.name,
                    file: "",
                    type: file?.type.split("/")[1],
                    size: getFileSize(file.size),
                    isUpload: false,
                },
            ];
            if (allowFilesTypeInvoice.includes(file.type)) {
                setDocumentDetail(arr);
                handleUploadInvoice(file, arr);
            } else {
                ErrorToaster(
                    `Only ${CleanTypes(allowFilesTypeInvoice)} formats is supported`
                );
            }
        } catch (error) {
            ErrorToaster(error);
        }
    };



    const handleUploadInvoice2 = async (file, docs) => {
        setProgress2(0);
        try {
            const formData = new FormData();
            formData.append("document", file);
            const { data } = await instance.post(routes.uploadDocuments, formData, {
                onUploadProgress: (progressEvent) => {
                    const uploadedBytes = progressEvent.loaded;
                    const percentCompleted = Math.round(
                        (uploadedBytes * 100) / progressEvent.total
                    );

                    setProgress2(percentCompleted);
                    setUploadedSize2(getFileSize(uploadedBytes));
                },
            });
            if (data) {
                docs[0].isUpload = true;
                docs[0].file = data?.data?.nations;
                setDocumentDetail2(docs);
                setDocumentLink2(data?.data?.nations);
            }
        } catch (error) {
            ErrorToaster(error);
        }
    };



    const handleTitleStatusSearch = (searchTerm) => {
        if (searchTerm.trim() === "") {
            setFilteredTitleStatus(TitleStatus);
        } else {
            const filtered = TitleStatus.filter((status) =>
                status.name.toLowerCase().includes(searchTerm.toLowerCase())
            );
            setFilteredTitleStatus(filtered);
        }
    };

    // // *For Remove Picture
    // const removePicture = (index) => {
    //   try {
    //     let shallowPicture = [...pictures]
    //     shallowPicture.splice(index, 1)
    //     setPictures(shallowPicture)
    //   } catch (error) {
    //     ErrorToaster(error)
    //   }
    // }

    // *For Create Vehicle Booking
    const createVehicleBooking = async (formData) => {
        setLoading(true);
        try {
            let obj = {
                customer_id: selectedCustomer?.id,
                customer_name: selectedCustomer?.name,
                customer_phone: phoneNumber,
                buyer_id: selectedBuyerId?.id,
                towed_by: selectedVehicleTower?.id,
                buyer_account_id: selectedBuyerId?.account_id,
                vin: formData.vin,
                lot_number: formData.lotNumber,
                other_charges: formData.otherCharges
                    ? parseFloat(formData.otherCharges)?.toFixed(2)
                    : 0,
                make: selectedMake?.id,
                make_name: selectedMake?.name,
                model: selectedModel?.id,
                model_name: selectedModel?.name,
                color: selectedColor?.id,
                country_id: selectedCountry?.id,
                location_id: selectedState ? selectedState?.id : null,
                key: key,
                title_status: selectedTitleStatus?.id,
                title_status_key: titleStatus,
                vehicle_key: vehicleKey,
                title_receive_date: getYearMonthDateFormate(titleReceiveDate),
                value: parseFloat(formData.value)?.toFixed(2),
                currency: selectedCurrency?.id,
                ex_rate: selectedCurrency?.rate,
                purchase_date: getYearMonthDateFormate(purchaseDate),
                auctioneer: formData.auctioneer,
                pickup_date: getYearMonthDateFormate(pickupDate),
                delivery_date: getYearMonthDateFormate(deliveryDate),
                pictures: pictures,
                vehicle_type: selectedRate?.id,
                warehouse_id: selectedWarehouse?.id,
                notes: getValues("notes"),
                new_vehicle: true,
                // invoices: documentLink,
                // invoices2: documentLink2,
                booking_rate: getValues("bookingRate"),
                off_site: getValues("offSite"),
                gp_pin: getValues("gpPin"),
                master_id: getValues("masterId"),
                destination_id: selectedDestination?.id,
                invoice_documents: invoiceList.map((d) => ({
                    id: d.id,
                    doc_id: d.invoiceType,
                    file_path: d.documentLink2,
                })),

            };

            const { message } = await VehicleBookingServices.createVehicleBooking(
                obj
            );
            SuccessToaster(message);
            console.log(message, "updated value !!!");
            navigate("/vehicle-booking-list");
        } catch (error) {
            ErrorToaster(error);
        } finally {
            setLoading(false);
        }
    };
    // *For Create Make
    const createMake = async (name) => {
        try {
            let obj = {
                name: name,
            };
            const { data } = await SystemServices.createMake(obj);
            await getMakes();
            setSelectedMake(data?.make);
            setValue("make", data?.make?.name);
            return data?.make?.id;
        } catch (error) {
            ErrorToaster(error);
        }
    };


    // *For Create Model
    const createModel = async (name, makeid = null) => {
        try {
            let obj = {
                name: name,
                make_id: makeid || selectedMake?.id,
            };
            const { data } = await SystemServices.createModel(obj);
            await getModels(obj?.make_id);
            setSelectedModel(data?.model);
            setValue("model", data?.model?.name);
        } catch (error) {
            ErrorToaster(error);
        }
    };
    // *For Get Vehicle Towers
    const getVehicleTowers = async (search) => {
        try {
            let params = {
                page: 1,
                limit: 50,
                search: search,
            };
            const { data } = await SystemServices.getVehicleTowers(params);
            setVehicleTowers(data?.towing?.rows);
        } catch (error) {
            ErrorToaster(error);
        }
    };
    // *For Get Vehicle Towers
    const getWarehouses = async (search) => {
        try {
            let params = {
                page: 1,
                limit: 50,
                search: search,
            };
            const { data } = await SystemServices.getWarehouses(params);
            setWarehouses(data?.warehouses);
        } catch (error) {
            ErrorToaster(error);
        }
    };
    const handleExternalData = async () => {
        if (extractVinLength) {
            setLoader(true);
            try {
                let params = {
                    vin: getValues("externalVin"),
                };
                const data = await SystemServices.handleExternalData(params);

                let lastIndex = data?.data?.sale_history?.length - 1;

                if (data.statusCode == 404) {
                    ErrorToaster("Vin Not Found");
                } else {
                    setValue("vin", data?.vinData?.VIN);
                    setValue("lotNumber", data?.data?.lot_id);

                    let Curr = currencies.find((item) => item?.name == "USD");
                    handlePurchaseDate(data?.data?.sale_history[lastIndex]?.sale_date);
                    if (selectedBuyerId?.auction?.name == "Copart") {
                        setValue("currency", { id: "usd", name: "USD" });
                        setSelectedCurrency({ id: "usd", name: "USD" });
                    } else if (selectedBuyerId?.auction?.name == "IAAIs") {
                        setValue("currency", { id: "aed", name: "AED" });
                        setSelectedCurrency({ id: "aed", name: "AED" });
                    }

                    setValue(
                        "value",
                        data?.data?.sale_history[lastIndex]?.purchase_price
                    );
                    let getMake = data?.data?.year + " " + data?.data?.make;

                    let foundMake = makes.find(
                        (car) => car.name.toLowerCase() === getMake.toLowerCase()
                    );
                    let totalModels = models;
                    if (foundMake) {
                        totalModels = await getModels(foundMake?.id);
                    }
                    let foundModel = totalModels?.find(
                        (car) => car.name.toLowerCase() === data?.data?.model.toLowerCase()
                    );
                    const foundColor = colors.find(
                        (color) =>
                            color.name.toLowerCase() === data?.data?.color.toLowerCase()
                    );
                    const foundLocation = allLocations.find(
                        (location) =>
                            location.state_code.toLowerCase() ===
                            data?.data?.state.toLowerCase()
                    );
                    let newModels;

                    let newMake = false;
                    if (!foundMake) {
                        let makeid = await createMake(getMake);

                        if (makeid) {
                            await createModel(data?.data?.model, makeid);
                        }
                    } else {
                        setSelectedMake(data?.vinData?.Make);
                        setValue("make", data?.vinData?.Make);
                    }
                    if (foundMake && !foundModel) {
                        if (selectedMake?.id) {
                            await createModel(data?.data?.model);
                        }
                    } else if (foundModel) {
                        setSelectedModel(data?.vinData?.Model);
                        setValue("model", data?.vinData?.Model);
                    }
                    if (!foundColor) {
                        createColor(data?.data?.color);
                        getColors();
                    }

                    setSelectedColor({ id: data?.data?.color, name: data?.data?.color });
                    setValue("color", { id: data?.data?.color, name: data?.data?.color });
                    setKey(data?.data?.keys.toLowerCase());
                    setSelectedCountry({
                        id: foundLocation?.country_id,
                        name: foundLocation?.country_name,
                    });
                    setValue("country", {
                        id: foundLocation?.country_id,
                        name: data?.vinData?.PlantCountry,
                    });
                    if (foundLocation?.country_id) {
                        getStates(foundLocation?.country_id);
                    }
                    // setPictures(data?.data?.link_img_hd);
                    handlePickupDate(data?.data?.auction_date);
                    setSelectedTitleStatus({
                        id: data?.data?.title,
                        name: data?.data?.title,
                    });

                    setExternalData(data);
                }
            } catch (error) {
                ErrorToaster(error);
            } finally {
                setLoader(false);
            }
        } else {
            ErrorToaster("Extracted Vin Must Be 17 Characters Long");
        }
    };
    // *For TTs
    const handleBooking = async (value) => {
        try {
            let params = {
                page: 1,
                limit: 15,
                search: value,
            };

            const { data } = await ClientServices.getVehicleTT(params);

            if (data?.details) {
                // setValue("otherCharges", parseFloat(data?.details?.otherCharges).toFixed(2));
            }
        } catch (error) {
            ErrorToaster(error);
        }
    };

    const handleDeleteDocument = (id) => {
        setInvoiceList((prev) => prev.filter((d) => d.id !== id));
    };

    // *For Create Color
    const createColor = async (name) => {
        try {
            let obj = {
                color: name,
            };
            const { data } = await SystemServices.createColor(obj);
            getColors();
            setSelectedColor({ id: data?.color, name: data?.color });
            setValue("color", data?.color);
        } catch (error) {
            ErrorToaster(error);
        }
    };


    const downloadAllAttachments = async (documentLinks) => {

        if (!documentLinks || documentLinks.trim() === "") {
            ErrorToaster("No attachments available.");
            return;
        }

        const filePath = documentLinks.trim();
        const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${filePath}`;
        const fileExtension = filePath.split('.').pop();

        try {
            const response = await fetch(fileUrl);
            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement("a");
            link.href = blobUrl;
            link.setAttribute("download", `attachment.${fileExtension}`);
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            window.URL.revokeObjectURL(blobUrl); // Cleanup
            SuccessToaster("Downloading attachment...");
        } catch (error) {
            console.error("Download failed", error);
            ErrorToaster("Failed to download attachment.");
        }
    };


    // *For Upload Excel CSV
    // const uploadExcel = (e) => {
    //     try {
    //         if (e.target.files.length) {
    //             const inputFile = e.target.files[0];
    //             if ("text/csv" === inputFile.type) {
    //                 const reader = new FileReader();
    //                 reader.onload = async ({ target }) => {
    //                     const csv = Papa.parse(target.result, { header: true });
    //                     const [data] = csv?.data;
    //                     if (data && data["VIN"]) {
    //                         setValue("vin", data["VIN"]);
    //                         setValue("lotNumber", data["Lot Number"]);
    //                         setValue("currency", data["Currency"]?.toLowerCase());
    //                         setSelectedCurrency(data["Currency"]?.toLowerCase());
    //                         setValue(
    //                             "value",
    //                             parseFloat(data["Estimated Value"].replace(/[^0-9.]/g, ""))
    //                         );
    //                         setKey(data["Keys"]?.toLowerCase());
    //                         const findMake = makes.find(
    //                             (e) => e?.name?.toLowerCase() === data["Make"]?.toLowerCase()
    //                         );
    //                         if (findMake) {
    //                             setSelectedMake(findMake?.id);
    //                             setValue("make", findMake?.id);
    //                             getModels(findMake?.id, "", data["Model Detail"]);
    //                         } else {
    //                             createMake({ name: data["Make"] });
    //                         }
    //                         const findColor = colors.find(
    //                             (e) => e?.name?.toLowerCase() === data["Color"]?.toLowerCase()
    //                         );
    //                         if (findColor) {
    //                             setSelectedColor(findColor?.id);
    //                             setValue("color", findColor?.id);
    //                         } else {
    //                             createColor({ name: data["Color"] });
    //                         }
    //                     } else {
    //                         ErrorToaster("Please upload a valid CSV file.");
    //                     }
    //                 };
    //                 reader.readAsText(inputFile);
    //             } else {
    //                 ErrorToaster(`Only CSV formats is supported`);
    //             }
    //         }
    //     } catch (error) {
    //         ErrorToaster(error);
    //     }
    // };

    useEffect(() => {
        getCustomerBooking();
        getCurrencies();
        getMakes();
        getColors();
        getVehicleTowers();
        getCountries();
        getAllLocations();
        getWarehouses();
        setValue("rateType", { id: 3, name: "Auto" });
    }, []);
    const handleOpenModal = () => {
        setModalOpen(true);
    };

    const handleCloseModal = () => {
        setModalOpen(false);
    };
    // useEffect(() => {
    //   if (pictures.length > 0) {
    //     new Viewer(viewerRef?.current, {
    //       // options, such as zoom, navbar, etc.
    //     });

    //     // Clean up when the component unmounts
    //     // return () => {
    //     //   viewer.destroy();
    //     // };
    //   }
    // }, [pictures]);
    return (
        <Box
            className="your-component-container"
            sx={{
                m: 4,
                p: 5,
                // bgcolor: Colors.white,
                // borderRadius: 3,
                // boxShadow: "0px 8px 18px 0px #9B9B9B1A",
            }}
        >
            {loader && (
                <div className="bookingoverlay">
                    {" "}
                    <CircularProgress />{" "}
                </div>
            )}

            <Box component="form" onSubmit={handleSubmit(createVehicleBooking)}>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={12}>
                        <Typography
                            variant="h5"
                            sx={{
                                color: Colors.charcoalGrey,
                                fontFamily: FontFamily.NunitoRegular,
                                mb: 4,
                            }}
                        >
                            Book A Vehicle V2
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <Accordion
                        //  expanded={expanded === "customer"} 
                         expanded={!!expanded.customer}
                         onChange={handleChange("customer")}
                        sx={{
                            backgroundColor: "transparent",
                            boxShadow: "none",
                            "&:before": { display: "none" },
                        }}>
                            <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                                <Typography>Customer Details*</Typography>
                            </AccordionSummary>

                            <AccordionDetails>
                                <Grid container spacing={2} sx={{ mt: 0 }}>
                                    <Grid item xs={12} sm={4}>

                                        <SelectField
                                            onSearch={(v) => getCustomerBooking(v)}
                                            label={"Select Customer*"}
                                            options={customers}
                                            selected={selectedCustomer}
                                            onSelect={(value) => {
                                                setSelectedCustomer(value);
                                                setCustomerDetail(value);
                                            }}
                                            error={errors?.customer?.message}
                                            register={register("customer", {
                                                required: "Please select customer.",
                                            })}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <InputField
                                            disabled={true}
                                            label={"Customer ID"}
                                            placeholder={"Customer ID"}
                                            register={register("customerId")}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <InputField
                                            disabled={true}
                                            label={"Master ID"}
                                            placeholder={"Master ID"}
                                            register={register("masterId")}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <SelectField
                                            disabled={selectedCustomer ? false : true}
                                            label={"Buyer ID*"}
                                            options={buyerId}
                                            selected={selectedBuyerId}
                                            onSelect={(value) => {
                                                setSelectedBuyerId(value);
                                                setValue("auctioneer", value?.auction?.name);
                                                setValue("masterId", value?.master_id)
                                            }}
                                            error={errors?.buyerId?.message}
                                            register={register("buyerId", {
                                                required: "Please select buyer id.",
                                            })}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={4}>
                                        <InputField
                                            disabled={true}
                                            label={"Auctioneer"}
                                            placeholder={"Auctioneer"}
                                            register={register("auctioneer")}
                                        />
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion>
                    </Grid>
                </Grid>
                <Grid item xs={12} ml={2} mr={2}>
                    <Divider sx={{ my: 2, borderColor: "#B3B3B3" }} />
                </Grid>


                <Grid item xs={12}>
                    <Accordion 
                    // expanded={expanded === "vehicle"} 
                     expanded={!!expanded.vehicle}
                    onChange={handleChange("vehicle")} sx={{
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        "&:before": { display: "none" },
                    }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                            <Typography>Vehicle Details*</Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                            <Grid container spacing={2} sx={{ mt: 0 }}>
                                <Grid item xs={12} sm={4}>
                                    <DatePicker
                                        label={"Purchase Date*"}
                                        value={purchaseDate}
                                        error={errors?.purchaseDate?.message}
                                        register={register("purchaseDate", {
                                            required: "Please select purchase date",
                                        })}
                                        onChange={(date) => handlePurchaseDate(date)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <InputField
                                        label={"VIN*"}
                                        placeholder={"VIN"}
                                        error={errors?.vin?.message}
                                        register={register("vin", {
                                            required: "Please enter VIN.",
                                            pattern: {
                                                value: /^[^\-_]*$/,
                                                message: "VIN cannot contain hyphens (-) or underscores (_).",
                                            },
                                            onChange: (e) => {
                                                const trimmedVin = e.target.value.trim();
                                                if (trimmedVin.length == 20) {
                                                    setVinLength(false);
                                                } else {
                                                    setVinLength(true);
                                                    handleBooking(trimmedVin);
                                                }
                                                setValue("vin", trimmedVin);
                                            },
                                        })}
                                    />
                                    {vinLength ? (
                                        <Typography
                                            variant="body2"
                                            sx={{
                                                fontWeight: 700,
                                                fontFamily: FontFamily.NunitoRegular,
                                                color: "red",
                                            }}
                                        >
                                            Vin can be 20 Characters Long
                                        </Typography>
                                    ) : (
                                        ""
                                    )}
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <InputField
                                        label={"LOT*"}
                                        placeholder={"Lot"}
                                        error={errors?.lotNumber?.message}
                                        register={register("lotNumber", {
                                            required: "Please enter lot number.",
                                            onChange: (e) => {
                                                const trimmedLotNumber = e.target.value.trim();
                                                setValue("lotNumber", trimmedLotNumber);
                                            },
                                        })}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <SelectField
                                        label={"Currency*"}
                                        options={currencies}
                                        selected={selectedCurrency}
                                        onSelect={(value) => {
                                            setValue("bookingRate", value?.rate);
                                            setSelectedCurrency(value);
                                        }}
                                        type={"text"}
                                        error={errors?.currency?.message}
                                        register={register("currency", {
                                            required: "Please select currency.",
                                        })}
                                        disabled={true}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <InputField
                                        label={"Booking Rate*"}
                                        placeholder={"Booking Rate"}
                                        type={"text"}
                                        step={"any"}
                                        disabled={true}
                                        // defaultValue={cadExRate}
                                        error={errors?.value?.message}
                                        register={register("bookingRate", {
                                            // required: "Please enter value.",
                                            pattern: {
                                                value: numberRegex,
                                                // message: "Please enter a valid number.",
                                            },
                                        })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <InputField
                                        label={"Vehicle Value*"}
                                        placeholder={"Vehicle Value"}
                                        type={"text"}
                                        step={"any"}
                                        error={errors?.value?.message}
                                        register={register("value", {
                                            required: "Please enter value.",
                                            onChange: (e) => {
                                                let priceAmount = e.target.value.replace(/,/g, "");

                                                setValue("value", priceAmount);

                                                if (
                                                    !(
                                                        !priceAmount ||
                                                        priceAmount.match(/^\d{1,}(\.\d{0,2})?$/)
                                                    )
                                                ) {
                                                    setValue("value", parseFloat(priceAmount).toFixed(2));
                                                }
                                            },
                                            pattern: {
                                                value: numberRegex,
                                                message: "Please enter a valid number.",
                                            },
                                        })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <InputField
                                        type={"text"}
                                        label={"Other Charges"}
                                        placeholder={"Other Charges"}
                                        InputProps={{ inputProps: { min: 0 } }}
                                        register={register("otherCharges", {
                                            // required: "Please enter value.",
                                            onChange: (e) => {
                                                const priceAmount = e.target.value.replace(/,/g, "");
                                                setValue("otherCharges", priceAmount);

                                                if (
                                                    !(
                                                        !priceAmount ||
                                                        priceAmount.match(/^\d{1,}(\.\d{0,2})?$/)
                                                    )
                                                ) {
                                                    setValue(
                                                        "otherCharges",
                                                        parseFloat(priceAmount).toFixed(2)
                                                    );
                                                }
                                            },
                                            pattern: {
                                                value: numberRegex,
                                                message: "Please enter a valid number.",
                                            },
                                        })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={8}>
                                    <InputField
                                        label={"Notes"}
                                        placeholder={"Notes"}
                                        register={register("notes")}
                                    />
                                </Grid>

                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </Grid>
                <Grid item xs={12} ml={2} mr={2}>
                    <Divider sx={{ my: 2, borderColor: "#B3B3B3" }} />
                </Grid>



                <Grid item xs={12}>
                    <Accordion 
                      expanded={!!expanded.Spec}
                    //    expanded={expanded === "Spec"}
                        onChange={handleChange("Spec")} sx={{
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        "&:before": { display: "none" },
                    }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                            <Typography>Vehicle Specification*</Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                            <Grid container spacing={2} sx={{ mt: 0 }}>
                                <Grid item xs={12} sm={4}>
                                    <SelectField
                                        label={"Vehicle Type"}
                                        options={rateTypeOptions}
                                        selected={selectedRate}
                                        error={errors?.rateType?.message}
                                        register={register("rateType", {
                                            required: "Please select type.",
                                        })}
                                        onSelect={(value) => setSelectedRate(value)}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <SelectField
                                        addNew={(newValue) => createModel(newValue)}
                                        onSearch={(v) => getModels(selectedMake?.id, v)}
                                        label={"Model*"}
                                        options={models}
                                        selected={selectedModel}
                                        onSelect={(value) => setSelectedModel(value)}
                                        error={errors?.model?.message}
                                        register={register("model", {
                                            required: "Please select model.",
                                        })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <SelectField
                                        addNew={(newValue) => createMake(newValue)}
                                        onSearch={(v) => getMakes(v)}
                                        label={"Make*"}
                                        options={makes}
                                        selected={selectedMake}
                                        onSelect={(value) => {
                                            setSelectedMake(value);
                                            getModels(value?.id);
                                            // setSelectedModel(null);
                                        }}
                                        error={errors?.make?.message}
                                        register={register("make", {
                                            required: "Please select make.",
                                        })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <SelectField
                                        addNew={(newValue) => createColor(newValue)}
                                        onSearch={(v) => getColors(v)}
                                        label={"Color*"}
                                        options={colors}
                                        selected={selectedColor}
                                        onSelect={(value) => setSelectedColor(value)}
                                        error={errors?.color?.message}
                                        register={register("color", {
                                            required: "Please select color.",
                                        })}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <SelectField
                                        label={"Country*"}
                                        options={countries}
                                        selected={selectedCountry}
                                        onSelect={(value) => {
                                            setSelectedCountry(value);
                                            getStates(value?.id);
                                            setSelectedState(null);
                                            setSelectedCity(null);
                                        }}
                                        error={errors?.country?.message}
                                        register={register("country", {
                                            required: "Please select country.",
                                        })}
                                    />
                                </Grid>

                                <Grid item xs={12} sm={4}>
                                    <SelectField
                                        onSearch={(v) => getStates(selectedCountry?.id, v)}
                                        disabled={selectedCountry ? false : true}
                                        label={"Location"}
                                        options={states}
                                        selected={selectedState}
                                        onSelect={(value) => {
                                            setSelectedState(value);
                                            setSelectedCity(null);
                                        }}
                                        register={register("state & City", {
                                            required: "Please select Location.",
                                        })}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={4}>
                                    <InputField
                                        label={"Off Site"}
                                        placeholder={"Off Site"}
                                        register={register("offSite")}
                                    />
                                </Grid>

                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </Grid>
                <Grid item xs={12} ml={2} mr={2}>
                    <Divider sx={{ my: 2, borderColor: "#B3B3B3" }} />
                </Grid>






                <Grid item xs={12}>
                    <Accordion 
                     expanded={!!expanded.title}
                    // expanded={expanded === "title"} 
                    onChange={handleChange("title")} sx={{
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        "&:before": { display: "none" },
                    }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                            <Typography>Title & Keys</Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                            <Grid container spacing={2} sx={{ mt: 0 }}>

                                <Grid item xs={4} sm={4}>
                                    <Grid item xs={12}>
                                        <SelectField
                                            onSearch={(v) => handleTitleStatusSearch(v)}
                                            label={"Title Name"}
                                            options={filteredTitleStatus}
                                            selected={selectedTitleStatus}
                                            onSelect={(value) => setSelectedTitleStatus(value)}
                                            register={register("titleStatus")}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <DatePicker
                                            label={"Title Receive Date"}
                                            value={titleReceiveDate}
                                            onChange={(date) => handleTitleReceiveDate(date)}
                                        />
                                    </Grid>
                                    <Grid item xs={12} mt={1}>
                                        <InputField
                                            label={"GP PIN"}
                                            placeholder={"GP PIN"}
                                            register={register("gpPin")}
                                        />
                                    </Grid>

                                    <Grid item xs={12} sx={{ display: "flex" }}>
                                        <InputLabel sx={{ marginTop: "10px", marginRight: "10px" }}>Title Status</InputLabel>
                                        <FormControl>
                                            <RadioGroup
                                                row
                                                value={titleStatus}
                                                onChange={(e) => setTitleSatus(e.target.value)}
                                            >
                                                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                                                <FormControlLabel value="no" control={<Radio />} label="No" />
                                                <FormControlLabel
                                                    value="N/A"
                                                    control={<Radio />}
                                                    label="None"
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                </Grid>


                                <Grid item xs={2} sx={{ display: "flex", justifyContent: "center" }}>
                                    <Divider orientation="vertical" flexItem mx={1} sx={{ borderColor: "#B3B3B3" }} />
                                </Grid>

                                <Grid item xs={6} sm={6}>
                                    <Grid item xs={12} sx={{ display: "flex" }}>
                                        <InputLabel sx={{ marginTop: "10px", marginRight: "10px" }}>Vehicle Key</InputLabel>
                                        <FormControl>
                                            <RadioGroup
                                                row
                                                value={vehicleKey}
                                                onChange={(e) => setVehicleKey(e.target.value)}
                                            >
                                                <FormControlLabel value="yes" control={<Radio />} label="Yes" />
                                                <FormControlLabel value="no" control={<Radio />} label="No" />
                                                <FormControlLabel
                                                    value="N/A"
                                                    control={<Radio />}
                                                    label="None"
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>

                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </Grid>
                <Grid item xs={12} ml={2} mr={2}>
                    <Divider sx={{ my: 2, borderColor: "#B3B3B3" }} />
                </Grid>



                <Grid item xs={12}>
                    <Accordion 
                      expanded={!!expanded.Attachment}

                    // expanded={expanded === "Attachment"} 
                    onChange={handleChange("Attachment")} sx={{
                        backgroundColor: "transparent",
                        boxShadow: "none",
                        "&:before": { display: "none" },
                    }}>
                        <AccordionSummary expandIcon={<ExpandMoreIcon />} >
                            <Typography>Attachments*</Typography>
                        </AccordionSummary>

                        <AccordionDetails>
                            <Grid container spacing={2} sx={{ mt: 0 }}>
                                <Grid item xs={12} sm={12}>
                                    <AttachmentsCard
                                        onPickFiles={handleUploadDocument}
                                        onGetImages={() => console.log("Get Images clicked")}
                                        images={pictures}
                                        onRemove={removePicture}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <Divider sx={{ my: 2, borderColor: "#B3B3B3" }} />
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <SelectField
                                        label="Auction Invoice"
                                        options={[{
                                            id: 1, name: "At the time of purchase"
                                        }, {
                                            id: 2, name: "At the time of delivery"

                                        }]}
                                        selected={invoiceType}
                                        onSelect={(value) => {
                                            setInvoiceType(value);

                                        }}
                                        // error={errors?.customer?.message}
                                        register={register("periodicInvoice", {
                                            // required: "Please select invoice.",
                                        })}
                                    />

                                </Grid>

                                {/* <Grid item xs={12} sm={3}>
                                    <InputField
                                        fullWidth
                                        label="Invoice Number"
                                        value={invoiceNumber}
                                        onChange={(e) => setInvoiceNumber(e.target.value)}
                                    />
                                </Grid> */}

                                <Grid item xs={12} sm={3} mt={3.7}>
                                    <UploadFile
                                        custom={true}
                                        style={{
                                            backgroundColor: "#e7efeb",
                                            width: "100%",
                                            height: "40px",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            padding: "20px",
                                            border: "1px dashed #aeb1b0",
                                            borderRadius: "10px",
                                        }}
                                        register={register("scanned", {
                                            onChange: (e) => handleUploadDocumentInvoices(e),
                                        })}
                                    />
                                    {/* <UploadFile
                                        custom={true}
                                        multiple={true}
                                        style={{
                                            backgroundColor: "#e7efeb",
                                            width: "100%",
                                            height: "60px",
                                            display: "flex",
                                            justifyContent: "space-between",
                                            padding: "20px",
                                            border: "1px dashed #aeb1b0",
                                            borderRadius: "10px",
                                        }}
                                        accept={allowFilesType}
                                        error={errors?.scanned2?.message}
                                        register={register("invoices", {
                                            // required: "Please attach Decelaration.",
                                            onChange: (e) => handleUploadDocumentInvoices(e),
                                        })}
                                    /> */}
                                </Grid>
                                <Grid item xs={12} sm={1} sx={{ textAlign: "right" }} mt={4}>
                                    <IconButton
                                        size="small"
                                        onClick={handleAddDocument}
                                        sx={{
                                            bgcolor: Colors.primary,
                                            color: Colors.white,
                                            "&:hover": {
                                                bgcolor: Colors.primary,
                                                color: Colors.white,
                                            },
                                        }}
                                    >
                                        <Add />
                                    </IconButton>
                                </Grid>

                                {
                                    invoiceList.length > 0 ? (
                                        <>
                                            <Grid item xs={12} sm={12}>
                                                <TableContainer component={Paper}>
                                                    <Table sx={{ minWidth: 650 }} aria-label="Documents Table">
                                                        <TableHead sx={{ bgcolor: Colors.primary, color: Colors.white }}>
                                                            <TableRow>
                                                                <Cell>Invoice Type</Cell>
                                                                <Cell>Attachment</Cell>
                                                                <Cell>Action</Cell>
                                                            </TableRow>
                                                        </TableHead>
                                                        <TableBody>
                                                            {invoiceList.map((doc) => (
                                                                <TableRow key={doc?.id}>
                                                                    <TableCell>{doc?.invoiceTypeName}</TableCell>
                                                                    <TableCell>

                                                                        {doc?.documentLink2 && doc?.documentLink2 ? (
                                                                            <div style={{ cursor: "pointer" }} onClick={() => downloadAllAttachments(doc?.documentLink2)}>
                                                                                <FiDownload color={Colors.primary} size={25} />
                                                                            </div>
                                                                        ) : (
                                                                            <FiDownload color="gray" size={25} />
                                                                        )}
                                                                    </TableCell>
                                                                    <TableCell>
                                                                        <IconButton
                                                                            aria-label="delete document"
                                                                            onClick={() => handleDeleteDocument(doc.id)}
                                                                            sx={{ color: Colors.danger }}
                                                                        >
                                                                            <DeleteIcon />
                                                                        </IconButton>
                                                                    </TableCell>
                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>
                                                </TableContainer>
                                            </Grid>

                                        </>
                                    ) : (
                                        <>
                                        </>
                                    )
                                }



                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </Grid>
                {/* <Grid item xs={12} ml={2} mr={2}>
                    <Divider sx={{ my: 2, borderColor: "#B3B3B3" }} />
                </Grid> */}

                {/* Sticky footer submit */}
                <Box
                    sx={{
                        bottom: 0,
                        pt: 2,
                        mt: 2,

                    }}
                >
                    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 1 }}>
                        <PrimaryButton
                            title="Submit"
                            type='submit'
                            loading={loading}
                        />

                    </Box>
                </Box>





            </Box>


        </Box>
    );
}

export default CreateVehicleBookingV2;
